import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from "reactstrap";
import "./OrderDetails.css";
import {
  FaChevronLeft,
  FaCheck,
  FaHourglassHalf,
  FaTimes,
} from "react-icons/fa";
import { useSelector } from "react-redux";

const OrderDetails = ({ onBack, statusUpdate, onCompletePayment }) => {
  const { selectedOrder } = useSelector((state) => state.orders);
  const [activeTab, setActiveTab] = useState("service");
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isPaymentCompleted = selectedOrder.paymentStatus === "COMPLETED";
  const isOrderApproved = selectedOrder.orderStatus === "APPROVED";
  const isOrderRejected = selectedOrder.orderStatus === "REJECTED";

  let paymentStepClass = "tracking-step";
  if (isPaymentCompleted) {
    paymentStepClass += " completed";
  } else {
    paymentStepClass += " current";
  }

  let approvalStepClass = "tracking-step";
  if (!isPaymentCompleted) {
    approvalStepClass += " pending";
  } else if (isOrderApproved) {
    approvalStepClass += " completed";
  } else if (isOrderRejected) {
    approvalStepClass += " rejected";
  } else {
    approvalStepClass += " current";
  }

  const approvalLabel = isOrderRejected ? "Order Rejected" : "Order Approval";

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  console.log(
    selectedOrder.paymentStatus === "PENDING" &&
      selectedOrder.createdBy === user.UserID,
    "paymentStatus"
  );
  console.log(
    selectedOrder.paymentStatus,
    selectedOrder.createdBy,
    user.UserID,
    "paymentStatus"
  );
  console.log(selectedOrder, "paymentStatus");
  return (
    <Container className="order-details-container">
      <Button className="order-details-back-button" onClick={onBack}>
        <FaChevronLeft /> Back to Orders
      </Button>
      <h2 className="order-details-title">
        Order Details - ID: {selectedOrder.Id}
      </h2>
      <Row>
        <Col md={12}>
          <Card className="order-details-card">
            <CardBody>
              {/* <h4 className="order-details-card-title">Order Information</h4> */}
              <Nav tabs className="order-details-tabs">
                <NavItem>
                  <NavLink
                    className={activeTab === "service" ? "active" : ""}
                    onClick={() => toggleTab("service")}
                  >
                    Service Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "payment" ? "active" : ""}
                    onClick={() => toggleTab("payment")}
                  >
                    Payment Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "parties" ? "active" : ""}
                    onClick={() => toggleTab("parties")}
                  >
                    Provider & Customer
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="service">
                  <div className="order-details-section">
                    <div className="order-details-item">
                      <b>Service:</b> {selectedOrder?.serviceName || "N/A"}
                    </div>
                    <div className={"order-details-item"}>
                      <b>Order Status:</b>{" "}
                      <span
                        className={
                          isOrderRejected
                            ? "tracking-rejected"
                            : isOrderApproved
                            ? "tracking-approved"
                            : isPaymentCompleted
                            ? "tracking-awaiting-approval"
                            : "tracking-payment-pending"
                        }
                      >
                        {isOrderRejected
                          ? "ORDER REJECTED"
                          : isOrderApproved
                          ? "ORDER APPROVED"
                          : isPaymentCompleted
                          ? "AWAITING APPROVAL"
                          : "PAYMENT PENDING"}
                      </span>
                    </div>
                    <div className="order-details-item">
                      <b>Created At:</b>{" "}
                      {new Date(selectedOrder.createdAt).toLocaleDateString()}
                    </div>
                    <div className="order-details-item">
                      <b>Date:</b> {selectedOrder.reserveDate || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Time:</b> {selectedOrder.startTime || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Message:</b>{" "}
                      {selectedOrder.Message || "No message provided"}
                    </div>
                    <div className="order-details-item">
                      <b>Deal Term:</b> {selectedOrder.dealTerm || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Package Details:</b>{" "}
                      {selectedOrder.packageDetails || "N/A"}
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="payment">
                  <div className="order-details-section">
                    <div className="order-details-item">
                      <b>Actual Price:</b> $
                      {parseFloat(selectedOrder.totalAmount || 0).toFixed(2)}
                    </div>
                    <div className="order-details-item">
                      <b>Discount:</b> $
                      {parseFloat(selectedOrder.Discount || 0).toFixed(2)}
                    </div>
                    <div className="order-details-item">
                      <b>Total Amount:</b> $
                      {parseFloat(selectedOrder.totalAmount || 0).toFixed(2)}
                    </div>
                    <div className="order-details-item">
                      <b>Paid Amount:</b> $
                      {parseFloat(selectedOrder.paidAmount || 0).toFixed(2)}
                    </div>
                    <div className="order-details-item">
                      <b>Final Price:</b> $
                      {parseFloat(selectedOrder.paidAmount || 0).toFixed(2)}
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="parties">
                  <div className="order-details-section">
                    <h5 className="order-details-subsection-title">
                      Provider Details
                    </h5>
                    <div className="order-details-item">
                      <b>Name:</b> {selectedOrder.provider?.name || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Contact:</b> {selectedOrder.provider?.contact || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Email:</b> {selectedOrder.provider?.email || "N/A"}
                    </div>
                    <h5 className="order-details-subsection-title">
                      Customer Details
                    </h5>
                    <div className="order-details-item">
                      <b>Name:</b>{" "}
                      {selectedOrder.customer?.name ||
                        selectedOrder.userName ||
                        "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Contact:</b> {selectedOrder?.Phone || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Email:</b> {selectedOrder?.Email || "N/A"}
                    </div>
                  </div>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col md={12}>
          <Card className="order-details-card">
            <CardBody>
              <h4 className="order-details-card-title">Order Tracking</h4>
              <div className="order-tracking-timeline">
                <ul className="tracking-steps">
                  <li className="tracking-step completed">
                    <div className="step-circle">
                      <FaCheck />
                    </div>
                    <p>Order Placed</p>
                  </li>
                  <li className={paymentStepClass}>
                    <div className="step-circle">
                      {isPaymentCompleted ? <FaCheck /> : <FaHourglassHalf />}
                    </div>
                    <p>Payment Pending</p>
                  </li>
                  <li className={approvalStepClass}>
                    <div className="step-circle">
                      {isOrderApproved ? (
                        <FaCheck />
                      ) : isOrderRejected ? (
                        <FaTimes />
                      ) : (
                        <FaHourglassHalf />
                      )}
                    </div>
                    <p>{approvalLabel}</p>
                  </li>
                </ul>
                <div className="tracking-actions">
                  {selectedOrder.paymentStatus === "PENDING" &&
                    selectedOrder.createdBy === user.UserID && (
                      <Button
                        className="tracking-action-button complete-payment"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering handleOrderClick
                          onCompletePayment(selectedOrder);
                        }}
                      >
                        Complete Payment
                      </Button>
                    )}
                  {selectedOrder.orderStatus === "PENDING" &&
                    selectedOrder.paymentStatus === "COMPLETED" &&
                    selectedOrder.ownerId == user.UserID && (
                      <div className="tracking-action-buttons">
                        <Button
                          className="tracking-action-button approve"
                          onClick={(e) =>
                            statusUpdate(e, selectedOrder, "APPROVED")
                          }
                        >
                          Approve
                        </Button>
                        <Button
                          className="tracking-action-button reject"
                          onClick={(e) =>
                            statusUpdate(e, selectedOrder, "REJECTED")
                          }
                        >
                          Reject
                        </Button>
                      </div>
                    )}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col md={12}>
          <h4 className="order-details-card-title">Images</h4>
          <div className="order-details-image-gallery">
            {/* {selectedOrder.Photo.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`Order image ${i + 1}`}
                className="selectedOrder-details-image"
              />
            ))} */}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default OrderDetails;
